//@flow
import { branch, renderComponent } from 'recompose'
import Loading from '../ui/views/loading'

const withLoadingUntilProps = (...requiredProps: string[]) =>
  branch(
    props => !requiredProps.every(propName => !!props[propName]),
    renderComponent(Loading)
  )

export default withLoadingUntilProps



// WEBPACK FOOTER //
// ./src/core/withLoadingUntilProps.js